import { render, staticRenderFns } from "./CCDeliveryPendingsWithThrollingDeliveryModal.vue?vue&type=template&id=f2fb274c"
import script from "./CCDeliveryPendingsWithThrollingDeliveryModal.vue?vue&type=script&lang=js"
export * from "./CCDeliveryPendingsWithThrollingDeliveryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports